// 手机号
const formatPhone = (phone) => {
    phone = "" + phone;
    return phone.substr(0, 3) + "****" + phone.substr(7, 11);
}

// 数字转换 大写字母
const AA = (value) => {
  return value;
  //return String.fromCharCode(Number(value)+64);
}
// 评分转换小数点
const BB = (value) => {
  let b=value;
  if(!b){
    b='0.0'
  }else{
    b=(value /10).toFixed(1);
  }
  return b
  //return String.fromCharCode(Number(value)+64);
}

export default {
  formatPhone,AA,BB
}




// WEBPACK FOOTER //
// ./src/filters/index.js